import { f7 } from 'framework7-vue';

export const HiNotification = {
  Toast(message, time) {
    const toastBottom = f7.toast.create({
      text: message,
      closeTimeout: time === undefined ? 2000 : time,
    });
    toastBottom.open();
  },

  Alert(textMessage, textTitle) {
    f7.dialog.alert(textMessage, textTitle);
  },
};

export const HiDialog = {
  Preloader(show, textMessagePreloader, allowCancel, textProcessCanceled) {
    const defaultTextPreloader = 'Cargando datos...';
    const funCancel = CancellationEvent;
    if (show) {
      f7.dialog.preloader(textMessagePreloader === undefined ? defaultTextPreloader : textMessagePreloader);
      document.addEventListener('backbutton', funCancel);
    } else {
      try {
        f7.dialog.close();
        document.removeEventListener('backbutton', funCancel);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    }
    function CancellationEvent() {
      if (allowCancel) {
        f7.dialog.close();
        document.removeEventListener('backbutton', funCancel);
        const defaultCancelText = allowCancel ? 'Proceso cancelado.' : 'No es posible cancelar el proceso.';
        HiNotification.Toast(textProcessCanceled !== undefined ? textProcessCanceled : defaultCancelText);
      }
    }
  },

};

/* PRELOADERGH */

let textoMensajePreloader = null;
let textoProcesoCancelado = null;
let permitirCancelar = null;

function AlertaDeCancelado() {
  if (permitirCancelar) {
    f7.dialog.close();
    document.removeEventListener('backbutton', AlertaDeCancelado);
  }

  HiNotification.Toast(textoProcesoCancelado);
}

export function PreloaderGH(estado, pPermitirCancelar, pTextoMensajePreloader, pTextoProcesoCancelado) {
  let txtPreloader = pTextoMensajePreloader;
  // Establecemos los valores por defecto
  if (pTextoMensajePreloader == null || pTextoMensajePreloader === undefined) {
    txtPreloader = 'Cargando datos...';
  }

  let txtProcesoCancelado = pTextoProcesoCancelado;
  // Establecemos los valores por defecto
  if (pTextoProcesoCancelado === null || pTextoProcesoCancelado === undefined) {
    if (pPermitirCancelar) {
      txtProcesoCancelado = 'Proceso cancelado.';
    } else {
      txtProcesoCancelado = 'No es posible cancelar el proceso.';
    }
  }
  try {
    if (estado) {
      textoMensajePreloader = txtPreloader;
      textoProcesoCancelado = txtProcesoCancelado;
      permitirCancelar = pPermitirCancelar;
      if (f7.dialog != null) {
        f7.dialog.close();
      }
      f7.dialog.preloader(textoMensajePreloader);
      document.addEventListener('backbutton', AlertaDeCancelado);
    } else {
      if (f7.dialog != null) {
        f7.dialog.close();
      }
      document.removeEventListener('backbutton', AlertaDeCancelado);
      textoMensajePreloader = null; // Restablecemos los valores.
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error);
  }
}

export async function ConfirmDialogGH(mensaje, titulo) {
  return new Promise(((resolve) => {
    function callbackOk() {
      resolve(true);
    }
    function callbackCancel() {
      resolve(false);
    }
    f7.dialog.confirm(mensaje, titulo, callbackOk, callbackCancel);
  }));
}
